import { getPresetRange } from "../components/DateRangePicker";

export const DEFAULT_PRESET_VIEWS = [
  // {
  //   id: 'expense_report',
  //   label: '{{STATS}} Expense Report',
  //   sublabel: 'Access current expense report',
  //   icon: 'Receipt',
  //   accentBg: '#f8e7e4',
  //   target: 'expenses',
  //   enabled: true,
  //   statsKey: 'currentReport',
  //   order: 0,
  // },
  //  {
  //   id: 'needs_review',
  //   label: '{{STATS}} transactions Need Review',
  //   sublabel: 'Unclassified transactions',
  //   icon: 'AlertCircle',
  //   accentBg: '#FFFBEB',
  //   target: 'bsv',
  //   filterSet: ['unclassified_debit', 'unclassified_credit'],
  //   groupBy: 'category',
  //   dateFrom: '',
  //   dateTo: '',
  //   title: 'Needs Review',
  //   enabled: true,
  //   statsKey: 'unreviewed',
  //   order: 1,
  // },
  // {
  //   id: 'business_pl',
  //   label: 'Business P&L',
  //   sublabel: 'Profit & Loss for business',
  //   icon: 'Briefcase',
  //   accentBg: '#c6d7f6',
  //   target: 'bsv',
  //   filterSet: ['business_income', 'business_expense', 'business_expense_refund'],
  //   groupBy: 'classification',
  //   dateFrom: getPresetRange('ytd').from,
  //   dateTo: getPresetRange('ytd').to,
  //   title: 'Business P&L',
  //   enabled: true,
  //   order: 2,
  // },
  {
    id: 'business_expenses',
    label: 'Business Expenses',
    sublabel: 'Classified as business expense',
    icon: 'BriefcaseAmber',
    accentBg: '#f8e7e4',
    target: 'bsv',
    filterSet: ['business_expense', 'business_expense_refund'],
    groupBy: 'category',
    dateFrom: getPresetRange('ytd').from,
    dateTo: getPresetRange('ytd').to,
    title: 'Business Expenses',
    enabled: true,
    order: 20,
  },
  
  {
    id: 'personal_pl',
    label: 'Personal P&L',
    sublabel: 'Profit & Loss for personal finances',
    icon: 'PersonalFinance',
    accentBg: '#c6d7f6',
    target: 'bsv',
    filterSet: ['personal_income', 'personal_expense', 'personal_expense_refund'],
    groupBy: 'classification',
    dateFrom: getPresetRange('ytd').from,
    dateTo: getPresetRange('ytd').to,
    title: 'Personal P&L',
    enabled: true,
    order: 3,
  },
  {
    id: 'personal_expenses',
    label: 'Personal Expenses',
    sublabel: 'Classified as personal expense',
    icon: 'PersonalExpense',
    accentBg: '#f8e7e4',
    target: 'bsv',
    filterSet: ['personal_expense', 'personal_expense_refund'],
    groupBy: 'category',
    dateFrom: getPresetRange('ytd').from,
    dateTo: getPresetRange('ytd').to ,
    title: 'Personal Expenses',
    enabled: true,
    order: 21,
  },
  {
    id: 'by_classification',
    label: 'Everything: By Classification',
    sublabel: 'All transactions grouped by classification',
    icon: 'BarChart2',
    accentBg: '#CCFBF1',
    target: 'bsv',
    filterSet: null,
    groupBy: 'classification',
    dateFrom: getPresetRange('this_month').from,
    dateTo: getPresetRange('this_month').to,
    title: 'Everything: By Classification',
    enabled: true,
    order: 10,
  },
  {
    id: 'by_category',
    label: 'Everything: By Category',
    sublabel: 'All transactions grouped by category',
    icon: 'BarChart2Navy',
    accentBg: '#EFF6FF',
    target: 'bsv',
    filterSet: null,
    groupBy: 'category',
    dateFrom: getPresetRange('this_month').from,
    dateTo: getPresetRange('this_month').to,
    title: 'Everything: By Category',
    enabled: true,
    order: 11,
  },

  {
    id: 'all_income',
    label: 'All Business & Personal Income',
    sublabel: 'Business & personal income grouped by category',
    icon: 'HandCoins',
    accentBg: '#ecfff3',
    target: 'bsv',
    filterSet: ['business_income', 'personal_income'],
    groupBy: 'category',
    dateFrom: getPresetRange('ytd').from,
    dateTo: getPresetRange('ytd').to,
    title: 'All Business & Personal Income',
    enabled: true,
    order: 12,
  },
    {
    id: 'all_expenses',
    label: 'All Business & Personal Expenses',
    sublabel: 'Business & personal expenses grouped by category',
    icon: 'Banknote',
    accentBg: '#f8e7e4',
    target: 'bsv',
    filterSet: ['business_expense', 'business_expense_refund', 'personal_expense', 'personal_expense_refund'],
    groupBy: 'category',
    dateFrom: getPresetRange('ytd').from,
    dateTo: getPresetRange('ytd').to,
    title: 'All Business & Personal Expenses',
    enabled: true,
    order: 13,
  },
 
  //    {
  //   id: 'all_accounts',
  //   label: 'View {{STATS}} Accounts',
  //   sublabel: 'View all bank and credit card accounts from which transactions have been imported',
  //   icon: 'Landmark',
  //   accentBg: '#EFF6FF',
  //   target: 'bsv',
  //   filterSet: null,
  //   fileSelection: 'transaction',
  //   groupBy: 'tx_account',
  //   dateFrom: '', dateTo: '',  // all_time
  //   title: 'All Accounts',
  //   statsKey: 'accountCount',
  //   enabled: true,
  //   order: 4,
  // },
  //   {
  //   id: 'expense_reports',
  //   label: 'View {{STATS}} Expense Reports',
  //   sublabel: 'View all current and past expense reports',
  //   icon: 'Receipt',
  //   accentBg: '#f8e7e4',
  //   target: 'bsv',
  //   filterSet: null,
  //   fileSelection: 'expense',
  //   groupBy: 'expense_report',
  //   dateFrom: '', dateTo: '',  // all_time
  //   enabled: true,
  //   statsKey: 'reportCount',
  //   order: 5,
  // },
];
